module.exports = __webpack_public_path__ + "img/gold.cdc4c5bd.png";